if (!customElements.get("availability-tab")) {
  customElements.define("availability-tab",
    class AvailabilityTab extends HTMLElement {
      constructor() {
        super();
        this.dataContainer = this.querySelector("[data-variants]");
        this.globals = window.productGlobals;
        this.variants = this.globals.variants;
        this.messages = this.globals.messages;
        this.dropshipFlag = this.globals.dropshipFlag === "true";
        this.productType = this.globals.productType || ""; // Get product type from globals
        this.messageSpan = this.querySelector("[data-availability]");
        this.productInput = document.querySelector(
          '.product-form input[name="id"]'
        );
      }
      connectedCallback() {
        this.renderMessage(null);
        this.setupListener();
      }
      setupListener() {
        this.productInput.addEventListener("change", (evt) => {
          this.renderMessage(evt);
        });
      }
      renderMessage(evt) {
        let variantId = evt ? evt.target.value : this.productInput.value;
        const variant = this.variants.find((v) => v.id == variantId);
        const messages = this.messages;
        
        // Check if product is a Gift Card and shipping message exists
        if (this.productType === "Gift Card" && messages.shippingMessage) {
          this.messageSpan.innerHTML = messages.shippingMessage;
          return;
        }

        // Existing logic for other product types
        if (variant.inventoryQty > 0) {
          this.messageSpan.innerHTML = messages.available;
          return;
        }
        if (variant.inventoryPolicy === "deny") {
          this.messageSpan.innerHTML = messages.outOfStock;
          return;
        }
        if (this.dropshipFlag) {
          this.messageSpan.innerHTML = messages.shippingMessage;
          return;
        }
        if (variant.availabilityDate && new Date(variant.availabilityDate) > new Date() && variant.inventoryPolicy === "continue") {
          this.messageSpan.innerHTML = messages.backOrder.replace("**date**", variant.availabilityDate);
          return;
        }
        this.messageSpan.innerHTML = messages.outOfStock;
      }
    }
  );
}